type Kind = "privacy" | "terms";

export function LegalPage({ kind }: { kind: Kind }) {
  if (kind === "privacy") {
    return (
      <div className="prose">
        <p className="mono-label">Legal</p>
        <h1>Privacy</h1>
        <p>
          PVPInsight is designed local-first. Fight recordings and analysis begin on your computer.
          Optional cloud sync uses private object storage and per-installation tokens. We do not sell
          fight data. Diagnostic uploads are opt-in when offered.
        </p>
        <p>
          This static marketing page is a concise public summary. The desktop application may show
          additional privacy controls for analytics preferences and sync.
        </p>
      </div>
    );
  }

  return (
    <div className="prose">
      <p className="mono-label">Legal</p>
      <h1>Terms</h1>
      <p>
        PVPInsight is provided as an alpha Windows application for Minecraft PvP analytics. Features
        may change. Unsupported kits and incomplete telemetry are labeled rather than invented.
      </p>
      <p>
        You are responsible for complying with Minecraft and server rules where you play. Reverse
        engineering, redistributing signed update artifacts, or abusing cloud APIs is not permitted.
      </p>
    </div>
  );
}
